import React, { useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import {
  sortGolfLeaderboardPositions,
  sortGolfToPars,
  updateLocalMinMaxVal,
} from "../../../../../../Utils";
import "./LiveScorecards.css";
import LiveTournamentToolTable from "../LiveTournamentToolTable";
import DraftkingsInfoOverlay from "../../../../../DraftKingsInfoOverlay";
import StatTable from "../../../../../StatTable";

const SCORECARDS = graphql`
  query LiveScorecardsQuery($eventId: ID!, $roundNumber: Int) {
    liveScorecardSummaries(eventId: $eventId, roundNumber: $roundNumber) {
      event {
        tournament {
          officialName
        }
      }

      nextRoundSalaryTitle

      playerSummaries {
        scorecardId

        player {
          id
          firstName
          lastName
          dkPlayer {
            id
          }
        }

        nextRoundSalary

        roundToPar
        eventToPar

        accDrives
        goodDrives

        accApps
        goodApps

        puttDist
        dkScore
        leaderboardPos
      }
    }
  }
`;

export default function LiveScorecards(props) {
  const queryData = useLazyLoadQuery(SCORECARDS, {
    eventId: props.selectedEventID,
    roundNumber: props.fullEvent ? null : props.roundNumber,
  });

  const [minMaxVals, setMinMaxVals] = useState({});
  const [selectedDkPlayerId, setSelectedDkPlayerId] = useState(undefined);

  const nextRoundSalaryTitle =
    queryData.liveScorecardSummaries.nextRoundSalaryTitle;

  const data = React.useMemo(() => {
    const localMinMax = {};

    const formattedData = queryData.liveScorecardSummaries.playerSummaries.map(
      (playerSummary) => {
        let newPlayerSummary = { ...playerSummary };

        newPlayerSummary.playerId = playerSummary.player.id;
        newPlayerSummary.playerName =
          playerSummary.player.firstName + " " + playerSummary.player.lastName;

        if (playerSummary.player.dkPlayer) {
          newPlayerSummary.dkPlayerId = playerSummary.player.dkPlayer.id;
        }

        newPlayerSummary.accDrives = `${playerSummary.accDrives}%`;
        newPlayerSummary.goodDrives = `${playerSummary.goodDrives}%`;
        newPlayerSummary.accApps = `${playerSummary.accApps}%`;
        newPlayerSummary.goodApps = `${playerSummary.goodApps}%`;

        updateLocalMinMaxVal(localMinMax, "accDrives", playerSummary.accDrives);
        updateLocalMinMaxVal(
          localMinMax,
          "goodDrives",
          playerSummary.goodDrives
        );
        updateLocalMinMaxVal(localMinMax, "accApps", playerSummary.accApps);
        updateLocalMinMaxVal(localMinMax, "goodApps", playerSummary.goodApps);
        updateLocalMinMaxVal(localMinMax, "puttDist", playerSummary.puttDist);
        updateLocalMinMaxVal(localMinMax, "dkScore", playerSummary.dkScore);

        return newPlayerSummary;
      }
    );

    setMinMaxVals(localMinMax);

    return formattedData;
  }, [props.selectedEventID]);

  let columns = [];

  if (props.roundNumber === null) {
    columns = [
      {
        Header: "Pos",
        accessor: "leaderboardPos",
        sortDescFirst: false,
        sortType: sortGolfLeaderboardPositions,
      },
    ];
  }

  columns.push({
    Header: "Name",
    accessor: "playerName",
    sortDescFirst: false,
  });

  if (nextRoundSalaryTitle) {
    columns.push({
      Header: nextRoundSalaryTitle,
      accessor: "nextRoundSalary",
      sortDescFirst: true,
    });
  }

  columns.push({
    Header: "Tot",
    accessor: "eventToPar",
    sortType: sortGolfToPars,
    sortInverted: true,
  });

  if (props.roundNumber) {
    columns.push({
      Header: "Rd",
      accessor: "roundToPar",
      sortType: sortGolfToPars,
      sortInverted: true,
    });
  }

  columns.push(
    ...[
      {
        Header: "Acc Drives",
        accessor: "accDrives",
      },
      {
        Header: "Good Drives",
        accessor: "goodDrives",
      },
      {
        Header: "Acc Apps",
        accessor: "accApps",
      },
      {
        Header: "Good Apps",
        accessor: "goodApps",
      },
      {
        Header: "Putt Dist",
        accessor: "puttDist",
        sortDescFirst: false,
      },
      {
        Header: "DK Score",
        accessor: "dkScore",
      },
    ]
  );
  console.log(columns);

  const myPlayerIds = props.myPlayers.map((player) => player.value);

  function showDKPlayerInfo(dkPlayerId) {
    if (dkPlayerId) {
      setSelectedDkPlayerId(dkPlayerId);
    }
  }

  function hideDKPlayerInfo() {
    setSelectedDkPlayerId(undefined);
  }

  return (
    <div className="pga-scorecards-container">
      <DraftkingsInfoOverlay
        show={selectedDkPlayerId !== undefined}
        playerId={selectedDkPlayerId}
        close={hideDKPlayerInfo}
      />
      <LiveTournamentToolTable
        data={data}
        columns={columns}
        roundNumber={props.roundNumber}
        myPlayerIds={myPlayerIds}
        minMaxVals={minMaxVals}
        showDKPlayerInfo={showDKPlayerInfo}
        showDrawer={props.roundNumber}
      />
    </div>
  );
}
